import React, { useMemo } from 'react'
import { useParams } from 'react-router'
import { useMyContext } from '../../context/context'
import { useGetSectionsQuery } from '../../api/v2/section'
import { useLanguage } from '../../hooks/useLanguages'

function pickLocalized(map, languageId, languageDefaultId) {
  if (!map || typeof map !== 'object') return null
  return map[languageId] || map[languageDefaultId] || Object.values(map).find(Boolean) || null
}

const Sections = () => {
  const { myContext } = useMyContext()
  const { sectionId } = useParams()
  const { languageId, languageDefault } = useLanguage()

  const { data: sections } = useGetSectionsQuery(myContext)

  const section = useMemo(() => sections?.find(f => f.id === Number(sectionId)), [sections, sectionId])

  if (section) {
    const html = pickLocalized(section.html, languageId, languageDefault?.id)?.html || ''
    return <div dangerouslySetInnerHTML={{ __html: html }} />
  }

  return null
}

export default Sections
